/**
 * Extract a flat list from a DRF-style API response body.
 *
 * Accepts either a bare array (unpaginated) or a paginated
 * `{ results: [...] }` envelope. Falls back to an empty array.
 */
export const extractList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
};

// PAGE_SIZE is 12 on every list endpoint. A caller that reads only page 1
// does not fail — it silently shows a subset, which is why this class of
// bug survives review and gets found in production instead (the board
// dropped a DONE task the moment a 13th task existed). The cap is a
// runaway guard, not a real limit; `truncated` says it was hit so a caller
// can surface that rather than lie.
export const MAX_PAGES = 20;

export const fetchAllPages = async (
  fetchPage,
  { maxPages = MAX_PAGES } = {},
) => {
  const items = [];
  let page = 1;
  let truncated = false;
  for (;;) {
    const response = await fetchPage(page);
    const data = response?.data;
    items.push(...extractList(data));
    // A bare array means the endpoint is not paginated at all.
    if (!data?.next) break;
    if (page >= maxPages) {
      truncated = true;
      break;
    }
    page += 1;
  }
  return { items, truncated };
};
